import {useTheme} from '@mui/material/styles';
import React, {memo, useEffect, useState} from 'react';
import {Box, Grid, InputLabel, Menu, Typography} from '@mui/material';
import MhdColorbarChoices from './MhdColorbarChoices';
import {
  cyclicColormaps,
  divergingColormaps,
  instrumentColormaps,
  miscellaneousColormaps,
  perceptuallyUniformSequentialColormaps,
  psiColormaps,
  sequential1Colormaps,
  sequential2Colormaps
} from '../../utils/colormaps';
import WidgetSwitch from './WidgetSwitch';
import Button from '@mui/material/Button';

const MhdColorbarWidget = ({ label, value, onChange }) => {
  const theme = useTheme()
  const [anchor, setAnchor] = useState(null);
  const [reversed, setReversed] = useState(false);
  const [cmap, setCmap] = useState(value);

  useEffect(() => {
    if (value.endsWith('_r')) {
      setCmap(value.slice(0, -2))
      setReversed(true)
    } else {
      setCmap(value)
      setReversed(false)
    }
  }, [value])

  const handleReverseChange = (v) => {
    onChange(v ? cmap + '_r' : cmap)
    setReversed(v);
  };

  return (
    <Box width={'100%'}>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        PaperProps={{
          sx: {
            borderRadius: '4px',
            width: '400px',
            minHeight: '400px',
            padding: 1
          },
        }}
        MenuListProps={{
          sx: {
            backgroundColor: 'background',
          },
        }}
      >
        <Typography fontSize={18} textAlign='right' color='primary'>COLORMAPS</Typography>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <MhdColorbarChoices
              label='Sequential (1)'
              value={cmap}
              onChange={(v) => onChange(reversed ? v + '_r' : v)}
              mappings={sequential1Colormaps}
            />
          </Grid>
          <Grid item xs={6}>
            <MhdColorbarChoices
              label='Sequential (2)'
              value={cmap}
              onChange={(v) => onChange(reversed ? v + '_r' : v)}
              mappings={sequential2Colormaps}
            />
          </Grid>
          <Grid item xs={6}>
            <MhdColorbarChoices
              label='Perceptually Uniform'
              value={cmap}
              onChange={(v) => onChange(reversed ? v + '_r' : v)}
              mappings={perceptuallyUniformSequentialColormaps}
            />
          </Grid>
          <Grid item xs={6}>
            <MhdColorbarChoices
              label='Instrument Specific'
              value={cmap}
              onChange={(v) => onChange(reversed ? v + '_r' : v)}
              mappings={instrumentColormaps}
            />
          </Grid>
          <Grid item xs={6}>
            <MhdColorbarChoices
              label='Diverging'
              value={cmap}
              onChange={(v) => onChange(reversed ? v + '_r' : v)}
              mappings={divergingColormaps}
            />
          </Grid>
          <Grid item xs={6}>
            <MhdColorbarChoices
              label='Cyclic'
              value={cmap}
              onChange={(v) => onChange(reversed ? v + '_r' : v)}
              mappings={cyclicColormaps}
            />
          </Grid>
          <Grid item xs={6}>
            <MhdColorbarChoices
              label='PSI Colormaps'
              value={cmap}
              onChange={(v) => onChange(reversed ? v + '_r' : v)}
              mappings={psiColormaps}
            />
          </Grid>
          <Grid item xs={6}>
            <MhdColorbarChoices
              label='Miscellaneous'
              value={cmap}
              onChange={(v) => onChange(reversed ? v + '_r' : v)}
              mappings={miscellaneousColormaps}
            />
          </Grid>
          <Grid item xs={3} />
          <Grid item xs={6}>
            <WidgetSwitch
              label='Reverse Colormap'
              value={reversed}
              onChange={handleReverseChange}
            />
          </Grid>
          <Grid item xs={3} />
          <Grid item xs={12}>
            <Box style={{ display: 'flex', width: '100%', padding:6, border: '2px solid #c5c5c5'}}>
              <img
                  src={`${process.env.PUBLIC_URL}/colormaps${reversed ? '_r' : ''}/${cmap}${reversed ? '_r' : ''}.jpg`}
                  alt={value}
                  style={{ display: 'flex', height: 60, width: '100%', borderRadius: 4}}
              />
              {/*<Typography fontSize={10}>{cmap}</Typography>*/}
            </Box>
          </Grid>
        </Grid>

      </Menu>

      <InputLabel variant='primary'>
        {label}
      </InputLabel>

      <Button
        onClick={(e) => setAnchor(e.currentTarget)}
        variant={'contained'}
        color={'background'}
        sx={{width: '100%', height: 30, padding: 0, borderRadius: '4px'}}
      >
        <img
          src={`${process.env.PUBLIC_URL}/colormaps${reversed ? '_r' : ''}/${cmap}${reversed ? '_r' : ''}.jpg`}
          alt={value}
          style={{height: '100%', width: '100%', borderRadius: '4px'}}
        />
      </Button>
      </Box>
  );
}

export default memo(MhdColorbarWidget);